import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from '@kubit/web-ui-components/hooks/useId';
import { ScreenReaderOnly } from '@kubit/web-ui-components/screenReaderOnly';
import { Text } from '@kubit/web-ui-components/text';
import { TextComponentType } from '@kubit/web-ui-components/text/types';
import { AriaLiveOptionType } from '@kubit/web-ui-components/types/ariaLiveOption';
import * as React from 'react';
import { TextCountContainerStyled } from './textCount.styled';
export const TEXT_COUNT_MAX_LENGTH = 99;
const TextCountStandAloneComponent = ({ styles, maxLength = TEXT_COUNT_MAX_LENGTH, currentCharacters, screenReaderText, disabled, }, ref) => {
    const dataTestId = 'text-count';
    const id = useId('textCount');
    const getAriaLive = () => {
        if (currentCharacters === 0 || currentCharacters >= maxLength) {
            return AriaLiveOptionType.POLITE;
        }
        return undefined;
    };
    return (_jsxs(TextCountContainerStyled, { ref: ref, "aria-live": getAriaLive(), "data-testid": dataTestId, styles: styles, children: [_jsx(ScreenReaderOnly, { id: id, children: screenReaderText }, currentCharacters), _jsx(Text, { "aria-hidden": true, component: TextComponentType.SPAN, customTypography: !disabled ? styles?.letfText : styles?.letfText?.disabled, children: currentCharacters }), _jsx(Text, { "aria-hidden": true, component: TextComponentType.SPAN, customTypography: !disabled ? styles?.rightText : styles?.rightText?.disabled, children: ` / ${maxLength}` })] }));
};
/**
 * @description
 * TextCount component is a component that can be used to create a counter of characters.
 * @param {React.PropsWithChildren<ITextCountControlled>} props
 * @returns {JSX.Element}
 */
export const TextCountStandAlone = React.forwardRef(TextCountStandAloneComponent);
//# sourceMappingURL=textCountStandAlone.js.map